/**
 * 구축 사례 상세 — 슬러그별 콘텐츠 (/project-details/:slug)
 */

export const PROJECT_DETAILS_SERVICE_SIDEBAR = [
    { category: 'UI/UX 기획', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '웹 서비스 개발', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '블록체인 서비스 개발', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '운영 시스템 구축', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
]

/** 통합 온라인 쇼핑몰(B2C) 구축 사례 상세 — 우측 서비스 박스 5개 */
export const PROJECT_DETAILS_B2C_ECOMMERCE_SIDEBAR = [
    { category: '쇼핑몰 구축 및 운영 시스템 개발', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '결제 및 주문 프로세스 연동', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '상품·회원·주문 관리 기능 구축', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '모바일 중심 반응형 인터페이스 설계', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '구매 전환을 고려한 사용자 경험 개선', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
]

/** B2C 몰 Android·iOS 앱 구축 사례 — 우측 서비스 박스 5개 */
export const PROJECT_DETAILS_B2C_MOBILE_APPS_SIDEBAR = [
    { category: 'Android·iOS 네이티브 앱 아키텍처 설계', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '몰 백엔드·결제·주문 API 연동', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '푸시·딥링크·앱 내 검색 경험 구축', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '스토어 심사·배포·버전 관리 프로세스', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '웹 몰과 통일된 브랜드·구매 동선 정렬', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
]

/** Premium Auto Concierge 구축 사례 — 우측 서비스 박스 */
export const PROJECT_DETAILS_PREMIUM_AUTO_CONCIERGE_SIDEBAR = [
    { category: '브랜드 랜딩·UI/UX', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '회원 인증·마이페이지', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '상담·견적·방문 예약', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '차량·프로모션 콘텐츠 관리', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: 'CRM 관리자·GA4 연동', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
]

/** 디지털 자산 거래 플랫폼 구축 사례 — 우측 서비스 박스 5개 */
export const PROJECT_DETAILS_DIGITAL_ASSETS_EXCHANGE_SIDEBAR = [
    { category: '디지털 자산 서비스 구축', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '거래 기능 및 주문 시스템 개발', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '지갑 및 자산 관리 기능 연동', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '운영 관리 시스템 구축', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
    { category: '모바일 반응형 UI 설계', icon: 'bi bi-arrow-right-short', routerPath: '/software-development' },
]

const genericInfo = (overrides = {}) => ({
    left: [
        ['클라이언트', overrides.client ?? '비공개 (B2B)'],
        ['착수', overrides.start ?? '2023년~'],
        ['기간', overrides.duration ?? '단계별 구축'],
        ['상태', overrides.status ?? '운영·고도화'],
    ],
    right: [
        ['유형', overrides.type ?? '웹·앱·백오피스'],
        ['진행 방식', overrides.mode ?? '서울 · 원격 혼합'],
        ['투입', overrides.team ?? '기획·디자인·개발'],
        ['결과', overrides.result ?? '납품 및 운영 지원'],
    ],
    tags: overrides.tags ?? '엔터프라이즈 / 맞춤 개발',
})

const CASE_STUDIES = {
    'blockchain-ecosystem': {
        meta: {
            title: '블록체인 생태계 웹·앱 구축 | CODAM 구축 사례',
            description:
                '암호화폐·NFT·실물자산 연계를 아우르는 생태계 소개, 스테이킹·결제·로드맵 UI 및 관리자·모바일 화면까지 CODAM이 구축한 비공개 클라이언트 사례입니다.',
        },
        pageTitle: {
            title: '블록체인 생태계 웹·앱 구축',
            parentTo: '/software-development',
            parentLabel: '소프트웨어 개발',
        },
        hero: {
            title: '블록체인 생태계 웹·앱 구축',
            lead:
                '비공개 클라이언트의 블록체인·NFT·실물자산을 연결하는 통합 생태계를 방문자에게 한눈에 전달하는 것이 목표였습니다. 결제(스테이블코인)·NFT 스테이킹·실물 연계 상품·투자자 참여 등 핵심 가치를 카드형으로 정리하고, 스테이킹 지갑·통합 서비스 메시지와 연도별 로드맵까지 한 스크롤 내러티브로 이어지도록 기획했습니다. 동일 브랜드 톤으로 메인 소개, NFT·실물 연계 상세, 관리자 대시보드, 모바일 홈·내 정보 UI를 맞춰 운영 효율과 신뢰감을 동시에 확보했습니다.',
        },
        info: {
            left: [
                ['클라이언트', '비공개 (B2B)'],
                ['착수', '2024년'],
                ['기간', '다회차·지속'],
                ['상태', '공개 운영·확장'],
            ],
            right: [
                ['유형', '블록체인·NFT 랜딩 · 관리자 · 모바일'],
                ['진행 방식', '서울 · 원격 혼합'],
                ['투입', '기획·디자인·프론트엔드'],
                ['결과', '런칭 및 운영 반영'],
            ],
            tags: 'Web3 / NFT / 플랫폼 / 반응형',
        },
        introParagraph:
            '프로젝트는 온·오프라인 채널, 커뮤니티, 금융 연계까지 아우르는 실물자산 연계 구조를 지향하며, 네이티브 토큰을 기축으로 스테이블코인·QR 결제·지갑 이전·자산 보관 등 결제 경험을 한 흐름으로 묶는 방향이었습니다. 방문자가 이 복합 메시지를 짧은 체류 안에 이해하도록 히어로·기능 카드·다이어그램·로드맵의 역할을 나누고 다크 블루 톤과 포인트 컬러로 시각 계층을 통일했습니다. 시맨틱 마크업·대체 텍스트 등 접근성 기본도 반영해 이후 카피·섹션 교체가 잦은 운영에 대비했습니다.',
        challenge: {
            body:
                'NFT 스테이킹 보상, 실물 연계 수익, 오프라인 갤러리·스토어, 메인넷·스테이블코인 운영, 메타버스 연계 등 장기 로드맵이 연도별로 제시되어 정보 밀도가 매우 높았습니다. 이를 한 페이지에 나열하면 가독성이 떨어지므로 단계·카테고리별로 시각적 리듬을 나누고, 모바일에서도 동일한 스토리가 유지되도록 브레이크포인트별 레이아웃을 재구성했습니다. CTA(지갑·참여 등)가 긴 스크롤 속에서도 자연스럽게 보이도록 배치하는 것이 핵심 과제였습니다.',
            bullets: [
                '결제·NFT 스테이킹·실물 연계·투자자 안내 네 축을 카드·다이어그램으로 구조화해 전달',
                '토큰 할당·생태계 다이어그램 등 숫자·비율 정보의 가독성과 브랜드 색 규칙 정리',
                '연도별 로드맵 등 시계열 콘텐츠를 스캔하기 쉬운 블록 단위로 설계',
            ],
        },
        previewSlides: [
            { src: '/assets/img/work/flc-rwa-ecosystem.png', alt: '블록체인 생태계 랜딩: 결제·NFT 스테이킹·실물 연계·투자자 안내' },
            { src: '/assets/img/work/ecosystem-platform-full-landing.png', alt: '브랜드 소개·토큰 할당·솔루션·푸터를 포함한 풀 스크린 페이지' },
            { src: '/assets/img/work/ecosystem-nft-rwa-landing.png', alt: '다종 PFP NFT·캐릭터 그리드 및 회원 혜택 안내 페이지' },
        ],
        goals: {
            body:
                '첫 방문자가 "암호화폐·NFT·실물자산을 연결하는 생태계"라는 한 문장 가치를 이해한 뒤, 결제·스테이킹·실물 연계·투자자 참여로 시선이 자연스럽게 확장되도록 했습니다. 공지·로드맵·캠페인 카피가 수시로 바뀌는 전제에서 섹션 모듈과 스타일 토큰을 정리해, 단계적 기능 공개 이후에도 레이아웃이 무너지지 않는 운영 기반을 마련했습니다.',
            counters: [
                { value: '15', suffix: '+', label: '랜딩·로드맵 블록' },
                { value: '12', suffix: '', label: 'PFP 캐릭터 NFT 유형' },
                { value: '4', suffix: '', label: '핵심 서비스 필라' },
                { value: '1', suffix: '', label: '통합 브랜드 UI' },
            ],
        },
        solution: {
            body:
                '메인·NFT·실물 연계 소개는 동일한 카드·타이틀·CTA 패턴으로 모듈화했고, 생태계·토큰 할당 등 수치 시각화는 차트·표를 병행해 가독성과 로딩을 균형 있게 맞췄습니다. 관리자 화면은 입출금·회원 지표 카드로 운영 흐름을 요약했고, 모바일은 홈·내 정보 등 실사용 동선을 반영했습니다. 스크롤 연출은 최소화해 성능과 접근성을 우선했으며, 아래 갤러리는 실제 구축 화면입니다.',
        },
        gallery: {
            images: [
                '/assets/img/work/flc-rwa-ecosystem.png',
                '/assets/img/work/ecosystem-platform-full-landing.png',
                '/assets/img/work/ecosystem-nft-rwa-landing.png',
                '/assets/img/work/ecosystem-admin-dashboard.png',
                '/assets/img/work/ecosystem-mobile-home.png',
                '/assets/img/work/ecosystem-mobile-myinfo.png',
            ],
            alts: [
                '블록체인 생태계 랜딩 풀 페이지',
                '브랜드 소개·토큰 할당·솔루션 풀 페이지',
                '다종 PFP NFT·캐릭터 그리드 페이지',
                '관리자 대시보드: 입출금·회원 지표',
                '모바일 앱 홈·자산·공지',
                '모바일 내 정보·메뉴·내비게이션',
            ],
        },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    /** 프리미엄 오토 컨시어지(PAC) — https://pac.codam.co.kr */
    'premium-auto-concierge': {
        meta: {
            title: '프리미엄 오토 컨시어지(PAC) 웹·CRM 구축 | CODAM 구축 사례',
            description:
                '메르세데스-벤츠 코리아 공식 딜러 KCC오토 강서목동 전담 컨설턴트 상담 사이트 pac.codam.co.kr. 모델·프로모션·견적·방문·시승 예약, 회원·출고 후기, CRM 관리자까지 CODAM이 구축한 프리미엄 오토 컨시어지 사례입니다.',
        },
        pageTitle: {
            title: '프리미엄 오토 컨시어지(PAC) 웹·CRM 구축',
            parentTo: '/software-development',
            parentLabel: '소프트웨어 개발',
            listTo: '/project-grid',
        },
        liveSiteUrl: 'https://pac.codam.co.kr',
        liveSiteLabel: 'pac.codam.co.kr',
        infoBackgroundImage: '/assets/img/work/premium-auto-concierge-landing.png',
        hero: {
            title: '프리미엄 오토 컨시어지(PAC) 웹·CRM 구축',
            lead:
                'Mercedes-Benz Korea 공식 딜러 KCC오토 소속 세일즈 컨설턴트와 1:1로 연결되는 프리미엄 오토 컨시어지(PAC)를 CODAM이 설계·개발했습니다. pac.codam.co.kr 에서 컨설턴트 소개·차량 라인업·이달의 프로모션·빠른 견적·방문·시승 예약까지 한 흐름으로 제공하고, 회원·마이페이지와 CRM 관리자를 통합해 상담·예약·콘텐츠를 운영할 수 있게 했습니다.',
        },
        info: {
            left: [
                ['클라이언트', 'KCC오토 (Mercedes-Benz Korea)'],
                ['서비스 URL', 'pac.codam.co.kr'],
                ['착수', '2026년~'],
                ['상태', '운영 중'],
            ],
            right: [
                ['유형', '브랜드 랜딩 · 회원 · CRM 관리자'],
                ['진행 방식', 'CODAM 기획·디자인·풀스택'],
                ['결과', '런칭·상담·예약 운영'],
            ],
            tags: '자동차 컨시어지 / 상담·견적·예약 / 회원·관리자 / 반응형',
        },
        introParagraph:
            'PAC는 “차량을 파는 공간”이 아니라 고객의 자동차 라이프를 함께 설계하는 1:1 컨설팅 채널입니다. 공개 사이트에서는 WHY PAC(공식 직원 전담·3-way 조건 비교·법인·개인 안내·출고 후 케어·VIP 상담) 메시지와 함께 2026년형 메르세데스-벤츠·AMG·Maybach·EQ 라인업, 이달의 프로모션, 인기 모델, 출고 스토리·회원 후기, 이벤트 갤러리·FAQ·공지를 제공합니다. 방문·시승 예약과 빠른 견적 문의 폼은 개인·법인·구매 방식(신차·리스·장기렌트)·희망 모델·금융 조건을 받아 30분 이내 상담으로 이어지도록 설계했고, 로그인 회원은 마이페이지에서 예약·문의 내역을 확인할 수 있습니다. 관리자(CRM)에서는 회원·상담·콘텐츠·차량 카탈로그·GA4 트래픽 지표를 운영합니다.',
        challenge: {
            body:
                '프리미엄 브랜드 톤(다크·골드)을 유지하면서 방대한 모델·프로모션·금융 정보를 스캔하기 쉽게 정리해야 했고, 공개 랜딩·회원 인증·예약·견적·관리자가 하나의 데이터 흐름으로 이어져야 했습니다. 공휴일·일요일 예약 제한, 견적 필드 검증, 관리자 세션·권한 등 운영 환경을 고려한 설계가 필요했습니다.',
            bullets: [
                '히어로·컨설턴트 카드·PAC 차별점 6종·프로모션·라인업 섹션의 정보 위계와 모바일 내비',
                '빠른 견적·방문·시승 예약: 유형·금융·모델·일정 필드와 개인정보 동의·유효성 검증',
                '회원 가입·로그인·마이페이지와 상담·예약 데이터 연동',
                '관리자 CRM: 회원·고객·공지·FAQ·이벤트·차량 카탈로그·GA4 대시보드',
            ],
        },
        previewSlides: [
            {
                src: '/assets/img/work/premium-auto-concierge-landing.png',
                alt: 'PAC 메인: 컨설턴트 히어로·Mercedes-Benz Korea KCC오토 브랜딩·상담 CTA',
            },
            {
                src: '/assets/img/work/premium-auto-concierge-mypage.png',
                alt: 'PAC 회원 마이페이지: 개요·보유 차량·견적·1:1 문의·공지·이벤트·모델 카탈로그',
            },
            {
                src: '/assets/img/work/premium-auto-concierge-admin.png',
                alt: 'PAC CRM 관리자: 접속 통계·견적·방문·시승 예약·1:1 문의·차량 카탈로그 운영',
            },
        ],
        goals: {
            body:
                '공식 딜러 컨설턴트 신뢰를 전면에 두고, 모델 비교·금융 조건·예약·견적까지 한 사이트에서 완결되게 하고, 상담 리드와 회원 데이터를 CRM에서 추적·관리할 수 있도록 하는 것을 목표로 했습니다. 모바일에서도 동일한 상담·예약 경험이 가능하도록 반응형 UI와 다크·라이트 테마를 지원했습니다.',
            counters: [
                { value: '6', suffix: '', label: 'PAC 차별점·가치 제안 블록' },
                { value: '4', suffix: '+', label: '차량 라인업(세단·SUV·AMG·Maybach·EQ)' },
                { value: '2', suffix: '', label: '예약 유형(방문·시승)' },
                { value: '1', suffix: '', label: '통합 CRM 관리자' },
            ],
        },
        solution: {
            body:
                'Express 기반 풀스택으로 공개 랜딩, 회원 영역, 관리자, API를 구성하고 회원·상담·예약·콘텐츠를 통합 관리합니다. 프론트는 섹션형 랜딩(히어로·프로모션 카드·라인업 그리드·출고·후기·갤러리·FAQ·공지)과 견적·예약 폼, 공휴일 캘린더 제한, 카카오·전화 FAB 등 전환 요소를 포함합니다. 관리자는 회원·고객·공지·FAQ·이벤트·차량 카탈로그를 CRUD하고 GA4 API 연동으로 트래픽·전환 지표를 확인합니다. 커스텀 도메인 pac.codam.co.kr 로 서비스 중이며, CODAM이 기획·UI·개발·배포까지 수행했습니다.',
        },
        gallery: {
            images: [
                '/assets/img/work/premium-auto-concierge-landing.png',
                '/assets/img/work/premium-auto-concierge-mypage.png',
                '/assets/img/work/premium-auto-concierge-admin.png',
            ],
            alts: [
                'pac.codam.co.kr — Premium Auto Concierge 메인 랜딩(히어로·컨설턴트·PAC 소개·프로모션·상담 CTA)',
                'PAC 회원 마이페이지 — 개요·보유 차량·견적·1:1 문의·공지·이벤트·모델 카탈로그',
                'PAC CRM 관리자 — 접속 통계·견적·방문·시승 예약·1:1 문의·차량 카탈로그 운영',
            ],
        },
        sidebar: PROJECT_DETAILS_PREMIUM_AUTO_CONCIERGE_SIDEBAR,
    },

    'digital-assets-exchange-platform': {
        meta: {
            title: '디지털 자산 거래 플랫폼 개발 | CODAM 구축 사례',
            description:
                '히어로·실시간 시세·온보딩이 있는 거래소 공개 진입 웹 개발과, 한국어 스팟 거래 터미널(차트·호가·체결·지정가·시장가 주문), 로그인 후 자산 허브(개요·현물·펀딩), 단계형 출금·네트워크 경고·FAQ, 펀딩↔현물 이체 모달, 보안(2FA·PIN·연락처·비밀번호)까지 한 웹 제품으로 묶어 개발한 사례입니다. 반응형 개발로 모바일·태블릿에서도 레이아웃 재구성·터치 동선을 맞춰 동일 플로우가 끊기지 않도록 구현했습니다.',
        },
        pageTitle: {
            title: '디지털 자산 거래 플랫폼 개발',
            parentTo: '/software-development',
            parentLabel: '소프트웨어 개발',
            listTo: '/project-grid',
        },
        infoBackgroundImage: '/assets/img/work/digital-assets-exchange-landing.png',
        hero: {
            title: '디지털 자산 거래 플랫폼 개발',
            lead:
                '홈페이지에서 브랜드·시세·보안·수수료 강점과 가입·입금까지 이어지는 온보딩을 한 스크롤에 담은 진입 웹을 개발했고, 로그인 후에는 상단 시장·거래·자산·주문 내비와 좌측 대시보드·자산·주문·계정 메뉴로 스팟 거래·잔고·입출금·이체·보안 설정까지 같은 다크·골드 톤으로 이어지게 구현했습니다. 거래 화면은 캔들 차트·호가·체결 내역·주문 패널을 한 레이아웃에 두었고, 출금은 코인·주소·네트워크·수량 단계와 우측 FAQ, 경고 박스로 실수를 줄이도록 구성했습니다. 반응형 개발을 적용해 태블릿·모바일에서는 글로벌 메뉴·사이드바를 접거나 드로어로 전환하고, 차트·호가·주문을 세로 스택과 탭으로 재배치하여 소형 화면에서도 동일 업무가 완결되도록 맞췄습니다.',
        },
        info: genericInfo({
            type: '핀테크 · 거래 플랫폼 (웹,앱)',
            tags: '다크·라이트 UI / 반응형(모바일·태블릿) / 스팟 거래 / 자산·출금·이체 / 보안·2FA',
            client: '비공개',
            start: '2026년',
            duration: '연속 개발·고도화',
        }),
        introParagraph:
            '글로벌 헤더(시장·거래·자산·주문)와 좌측 사이드바(대시보드, 자산 하위 개요·현물·펀딩, 주문·자산 내역, 계정의 보안·로그인 기록 등)가 고정된 채 본문만 바뀌는 구조입니다. 스팟 거래 탭에서는 마켓 검색·변동률 리스트·체결 내역과 중앙 차트(시간봉·지표), 우측 호가, 하단 지정가·시장가·예약 주문 폼이 한 화면에서 맞물립니다. 자산 영역에서는 예상 잔고와 입금·출금·이체·거래 내역 버튼, 코인별 현물·펀딩 잔고 표가 이어지고, 출금 플로우에서는 주소·내부 이체 전환·네트워크 선택과 “해당 네트워크로만 송금” 경고, 최근 출금 내역·우측 도움말 링크가 노출됩니다. 보안 화면에서는 점검 요약과 TOTP·PIN·휴대폰·이메일·로그인 비밀번호를 카드 단위로 관리합니다. 브레이크포인트별로 열 수·여백·폰트 스케일을 조정하는 반응형 개발을 통해 태블릿·모바일에서도 정보 위계가 유지되고, 모달·단계 폼·버튼은 터치 타깃과 간격을 넉넉히 두어 한 손 조작과 가로·세로 회전에 대응합니다.',
        challenge: {
            body:
                '거래소 UI는 공개 진입 웹 개발과 로그인 후 앱 셸·금융 플로우가 한 브랜드로 이어져야 하고, 호가·체결처럼 갱신이 잦은 영역과 단발성 폼(출금 주소·네트워크)이 같은 사용자에게 동시에 신뢰를 줘야 했습니다. 출금·이체는 잘못된 네트워크나 주소로 인한 자산 손실 위험이 커 경고·FAQ·단계 표시를 UX의 일부로 설계해야 했으며, 보안 설정은 미설정·설정됨 상태가 한눈에 들어오도록 시각 체계를 나눠야 했습니다. 또한 데스크톱용 다열 레이아웃을 모바일·태블릿 해상도로 옮길 때 패널 우선순위·접기·탭 전환 규칙을 정하지 않으면 차트·주문·자산 정보가 동시에 보이기 어렵다는 과제가 있었습니다.',
            bullets: [
                '스팟 거래: 차트·호가·체결·양쪽 주문 패널의 고정·스크롤 영역과 시간봉·주문 유형 탭 구조',
                '자산·출금: 개요·현물·펀딩·단계형 출금·코인 검색 드롭다운·네트워크 경고·이체 모달의 동선 일관성',
                '계정·보안: 보안 점검 요약과 2FA·PIN·연락처·비밀번호 카드',
                '반응형: 모바일·태블릿에서 내비·사이드바·거래·자산·출금·보안 화면의 열 재배치·터치 동선·모달 전체 폭 대응',
            ],
        },
        previewSlides: [
            {
                src: '/assets/img/work/digital-assets-exchange-landing.png',
                alt: '진입 웹 개발: 히어로 차트·실시간 시세·보안·체결 강점 카드·통계·4단계 온보딩·하단 정책 링크',
            },
            {
                src: '/assets/img/work/digital-assets-exchange-pro-btc.png',
                alt: '스팟 거래 BTC/USDT: 마켓 리스트·15m 캔들 차트·체결내역·호가·지정가·시장가 매수·매도',
            },
            {
                src: '/assets/img/work/digital-assets-exchange-pro-eth.png',
                alt: '스팟 거래 ETH/USDT: 동일 레이아웃·시세 바·호가 중앙 강조 가격',
            },
        ],
        goals: {
            body:
                '신규 사용자는 홈페이지(PC/모바일)에서 신뢰 신호와 시세를 보고 가입·입금까지 이해할 수 있게 하고, 거래자는 로그인 후 동일 내비게이션 안에서 차트 기반 주문과 자산 이동(입금·출금·펀딩↔현물 이체)을 끊기지 않게 완료하도록 하는 것을 목표로 했습니다. 스마트폰·태블릿에서도 반응형 레이아웃으로 동일 플로우가 완결되도록 구현하는 것을 함께 두었습니다.',
            counters: [
                { value: '4', suffix: '', label: '글로벌 메뉴(시장·거래·자산·주문)' },
                { value: '4', suffix: '', label: '진입·온보딩 단계 UI 개발' },
                { value: '3', suffix: '', label: '자산 지갑 탭(개요·현물·펀딩)' },
                { value: '4', suffix: '+', label: '보안·인증 채널 패널' },
            ],
        },
        solution: {
            body:
                '공개 진입 웹 개발에서는 히어로에서 거래 쌍·차트 위젯과 CTA를 묶고, 라이브 시세 행·기능 카드·숫자 요약·원형 아이콘 온보딩으로 스크롤 리듬을 나눴습니다. 거래 터미널은 좌측 마켓·체결, 중앙 차트, 우측 호가, 하단 대칭 주문 패널로 시야 이동을 최소화했고, 매수·매도 색과 변동률을 동일 규칙으로 썼습니다. 로그인 영역은 좌측 아코디언형 메뉴와 본문 카드 그리드로 자산 요약·테이블·최근 내역을 정돈했고, 출금은 단계 인디케이터·네트워크별 경고·FAQ 컬럼으로 안내를 보강했습니다. 이체는 모달에서 보내는·받는 계좌 유형과 코인·수량·가용 잔고를 한 번에 확인하게 했으며, 보안은 상단 점검 상태와 각 수단별 설정·관리 버튼을 분리해 운영 중에도 항목만 교체하기 쉽게 두었습니다. 반응형 개발로 뷰포트별 그리드를 나누고, 좁은 화면에서는 글로벌 내비·사이드바를 햄버거·오버레이로 전환하며 차트·호가·주문의 세로 순서와 최소 높이를 조정해 태블릿·모바일에서도 스크롤 과다 없이 거래·출금·이체·보안 설정을 마칠 수 있게 했습니다.',
        },
        gallery: {
            images: [
                '/assets/img/work/digital-assets-exchange-landing.png',
                '/assets/img/work/digital-assets-exchange-pro-btc.png',
                '/assets/img/work/digital-assets-exchange-pro-eth.png',
                '/assets/img/work/digital-assets-exchange-withdraw-flow.png',
                '/assets/img/work/digital-assets-exchange-assets-overview.png',
                '/assets/img/work/digital-assets-exchange-dashboard-home.png',
                '/assets/img/work/digital-assets-exchange-security-2fa.png',
                '/assets/img/work/digital-assets-exchange-withdraw-coin-select.png',
                '/assets/img/work/digital-assets-exchange-transfer-modal.png',
            ],
            alts: [
                '진입 웹 전체: 브랜드 히어로·라이브 시세·기능·통계·온보딩·CTA·푸터',
                '스팟 거래: BTC/USDT 캔들·호가·체결·지정가·시장가 주문(한국어)',
                '스팟 거래: ETH/USDT 동일 레이아웃',
                '출금: 코인 선택·주소/내부 이체·네트워크 경고·FAQ·최근 출금 내역',
                '자산 개요: 예상 잔고·입금·출금·이체·내 자산 테이블·최근 거래',
                '대시보드: 프로필·VIP·예상 잔고·보유 자산·입금 유도',
                '계정 보안: 점검 요약·TOTP·PIN·휴대폰·이메일·비밀번호 변경',
                '출금: 코인 검색 드롭다운·BTC·USDT·ETH·USDC 목록·단계 진행',
                '이체 모달: 펀딩↔현물·코인·수량·최대·가용 잔고·이체하기',
            ],
        },
        sidebar: PROJECT_DETAILS_DIGITAL_ASSETS_EXCHANGE_SIDEBAR,
    },

    'web-analytics-dashboard': {
        meta: {
            title: '웹 분석 대시보드 | CODAM 구축 사례',
            description: '운영·마케팅 KPI를 실시간으로 시각화하는 엔터프라이즈 웹 분석 대시보드 구축 사례입니다.',
        },
        pageTitle: { title: '웹 분석 대시보드', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '웹 분석 대시보드',
            lead: '다채널 유입·전환·이탈 지표를 한 화면에서 비교하고, 권한별로 공유 범위를 나눈 B2B 분석 화면입니다. 대용량 이벤트 로그와 배치 리포트를 병행해 경영·현장 모두가 동일한 숫자를 보도록 했습니다.',
        },
        info: genericInfo({
            type: '웹 애플리케이션 · 대시보드',
            tags: '데이터 시각화 / React / API 연동',
        }),
        introParagraph:
            '기존 스프레드시트·개별 툴에 흩어져 있던 지표를 표준 정의로 모았고, 필터·기간·세그먼트를 공통 컴포넌트로 묶어 유지보수 비용을 줄였습니다.',
        challenge: {
            body: '지표 정의가 부서마다 달라 동일 용어에도 다른 숫자가 나오는 문제가 있었습니다. 데이터 사전과 집계 파이프라인을 먼저 정리한 뒤 UI를 얹는 순서로 진행했습니다.',
            bullets: ['지표 정의 단일화 및 버전 관리', '권한·감사 로그를 고려한 조회 API 설계'],
        },
        previewSlides: [{ src: '/assets/img/work/project-1.jpg', alt: '웹 분석 대시보드 화면 예시' }],
        goals: {
            body: '일간·주간 리포트 자동 생성과 수동 드릴다운을 모두 지원해 운영 리듬에 맞추었습니다.',
            counters: [
                { value: '30', suffix: '+', label: '핵심 지표 위젯' },
                { value: '5', suffix: '', label: '권한 롤' },
            ],
        },
        solution: {
            body: '차트 라이브러리와 테이블 뷰를 역할에 맞게 배치하고, 느린 쿼리는 사전 집계·캐시로 응답 시간을 안정화했습니다.',
        },
        gallery: {
            images: ['/assets/img/work/project-1.jpg'],
            alts: ['웹 분석 대시보드 썸네일'],
        },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'unified-security-operations': {
        meta: {
            title: '통합 보안 관제 | CODAM 구축 사례',
            description: '자산·이벤트를 통합해 가시화하는 보안 관제 화면 및 알림 흐름 구축 사례입니다.',
        },
        pageTitle: { title: '통합 보안 관제', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '통합 보안 관제',
            lead: '다중 장비·클라우드 로그를 한 타임라인으로 모아 이상 징후를 빠르게 식별할 수 있는 관제 콘솔입니다.',
        },
        info: genericInfo({ type: '보안 · 관제 UI', tags: 'SIEM 연동 / 알림 / RBAC' }),
        introParagraph: '이벤트 정규화·우선순위 규칙·담당자 배정까지 한 흐름으로 설계했습니다.',
        challenge: {
            body: '소스별 로그 포맷이 달라 통합 검색이 어려웠습니다. 공통 스키마와 파서 파이프라인을 도입했습니다.',
            bullets: ['이벤트 상관관계 뷰', '에스컬레이션·티켓 연동'],
        },
        previewSlides: [{ src: '/assets/img/work/project-2.jpg', alt: '통합 보안 관제 화면' }],
        goals: {
            body: 'MTTD·MTTR 개선을 목표로 대시보드와 모바일 알림을 병행했습니다.',
            counters: [
                { value: '12', suffix: '', label: '연동 로그 소스' },
                { value: '3', suffix: '', label: '심각도 단계' },
            ],
        },
        solution: { body: '실시간 스트림과 배치 요약을 분리해 부하를 분산하고, 대시보드는 역할별 기본 뷰를 제공합니다.' },
        gallery: { images: ['/assets/img/work/project-2.jpg'], alts: ['통합 보안 관제'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'mobile-service-platform': {
        meta: {
            title: '모바일 서비스 플랫폼 | CODAM 구축 사례',
            description: '모바일 우선 UX와 결제·푸시 등 핵심 기능을 갖춘 서비스 플랫폼 구축 사례입니다.',
        },
        pageTitle: { title: '모바일 서비스 플랫폼', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '모바일 서비스 플랫폼',
            lead: '회원·결제·콘텐츠·알림을 아우르는 모바일 웹·앱 경험을 일관된 디자인 시스템으로 구현했습니다.',
        },
        info: genericInfo({ type: '모바일 · API', tags: '반응형 / 푸시 / 결제' }),
        introParagraph: '온보딩·주요 태스크 완료율을 기준으로 IA와 컴포넌트를 재배치했습니다.',
        challenge: {
            body: '네트워크 불안정 환경에서도 핵심 기능이 동작하도록 오프라인·재시도 정책을 정리했습니다.',
            bullets: ['스토어 심사 대응', '개인정보 최소 수집 설계'],
        },
        previewSlides: [{ src: '/assets/img/work/project-3.jpg', alt: '모바일 서비스 플랫폼' }],
        goals: {
            body: '전환 퍼널 단계별 지표를 추적할 수 있는 이벤트 계측을 포함했습니다.',
            counters: [
                { value: '8', suffix: '', label: '핵심 사용자 플로우' },
                { value: '99', suffix: '%', label: '가용성 목표' },
            ],
        },
        solution: { body: 'API 버전 정책과 앱 강제 업데이트 전략을 함께 정의해 운영 리스크를 줄였습니다.' },
        gallery: { images: ['/assets/img/work/project-3.jpg'], alts: ['모바일 서비스'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'brand-visual-identity': {
        meta: {
            title: '브랜드 비주얼 아이덴티티 | CODAM 구축 사례',
            description: '디지털 터치포인트에 일관되게 적용되는 브랜드 비주얼·UI 가이드 구축 사례입니다.',
        },
        pageTitle: { title: '브랜드 비주얼 아이덴티티', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '브랜드 비주얼 아이덴티티',
            lead: '로고·컬러·타이포·그리드·컴포넌트 토큰을 정리해 제품·마케팅 채널에 동일한 톤이 유지되도록 했습니다.',
        },
        info: genericInfo({ type: '브랜드 · UI 키트', tags: '디자인 시스템 / Figma' }),
        introParagraph: '개발팀이 바로 참조할 수 있도록 스토리북·토큰 export 파이프라인을 연결했습니다.',
        challenge: {
            body: '레거시 화면과 신규 브랜드가 공존하는 기간이 길어 단계적 마이그레이션 가이드가 필요했습니다.',
            bullets: ['접근성 대비 색 대비 규칙', '다국어 타이포 스케일'],
        },
        previewSlides: [{ src: '/assets/img/work/project-4.jpg', alt: '브랜드 비주얼' }],
        goals: {
            body: '신규 화면은 100% 가이드 준수를 목표로 리뷰 체크리스트를 두었습니다.',
            counters: [
                { value: '40', suffix: '+', label: 'UI 컴포넌트' },
                { value: '1', suffix: '', label: '단일 디자인 소스' },
            ],
        },
        solution: { body: '토큰 이름 규칙과 컴포넌트 변형(variant) 정책을 문서화해 협업 비용을 줄였습니다.' },
        gallery: { images: ['/assets/img/work/project-4.jpg'], alts: ['브랜드 비주얼'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    /** 소프트웨어 개발 페이지 구축 사례 슬라이더 — B2C 몰 풀페이지 UI */
    'b2c-ecommerce-platform': {
        meta: {
            title: '통합 온라인 쇼핑몰 플랫폼 구축 | CODAM 구축 사례',
            description:
                '메인·이벤트·베스트·카테고리 내비와 상품 그리드, 고객 지원·푸터까지 한 흐름으로 설계된 B2C 이커머스 웹 구축 사례입니다.',
        },
        pageTitle: {
            title: '통합 온라인 쇼핑몰 플랫폼 구축',
            parentTo: '/software-development',
            parentLabel: '소프트웨어 개발',
        },
        infoBackgroundImage: '/assets/img/work/b2c-mall-main-landing.png',
        hero: {
            title: '통합 온라인 쇼핑몰 플랫폼 구축',
            lead:
                '종합몰형 B2C 사이트로, 상단 글로벌 내비·검색·장바구니·회원 진입과 좌측 전체 카테고리, 메인 이벤트 배너·퀵 카테고리 아이콘, 베스트 상품 그리드, 하단 주문·배송 안내와 약관·고객센터까지 한 스크롤에 연결되는 구조를 구현했습니다. 프로모션·시즌 카피가 자주 바뀌는 전제에서 배너·타일 영역을 모듈화해 운영팀이 교체하기 쉽게 맞췄습니다.',
        },
        info: genericInfo({
            type: 'B2C 이커머스 · 반응형 웹',
            tags: '카탈로그 / 프로모션 / 주문·배송 안내',
            client: '비공개 (B2C 리테일)',
            start: '2024년',
            duration: '6개월',
        }),
        introParagraph:
            '실제 서비스 화면은 메인 히어로와 서브 배너로 행사·신선·추천 상품을 구분해 노출하고, 베스트 섹션에서는 품목 썸네일·가격·혜택 문구가 균일한 그리드로 정렬되도록 했습니다. 모바일·태블릿에서도 카테고리 진입과 상품 스캔이 끊기지 않도록 브레이크포인트별로 내비·그리드 열 수를 조정했고, 푸터에는 주문 조회·배송·교환·이벤트 등 고객 동선에 맞는 바로가기를 배치했습니다.',
        challenge: {
            body:
                '한 페이지에 배너·아이콘 그리드·다열 상품 리스트·정책 링크가 모두 포함되다 보니 시각적 위계가 무너지기 쉬웠습니다. 또한 행사 기간마다 배너 수와 노출 순서가 바뀌어 레이아웃이 흔들리지 않도록, 고정 높이·비율 규칙과 콘텐츠 슬롯을 정의하는 것이 과제였습니다.',
            bullets: [
                '전체 카테고리·가로 메뉴·검색이 동시에 노출될 때의 정보 밀도와 터치 타깃 정리',
                '베스트·이벤트 등 복수 그리드의 열 수·간격을 디바이스별로 통일',
                '푸터 고지·파트너 로고·고객센터 링크 등 신뢰 요소의 가독성 유지',
            ],
        },
        previewSlides: [
            {
                src: '/assets/img/work/b2c-mall-main-landing.png',
                alt: 'B2C 쇼핑몰 메인: 이벤트 배너, 카테고리, 베스트 상품 그리드, 푸터',
            },
            {
                src: '/assets/img/work/b2c-mall-best-products.png',
                alt: '베스트 상품: 카테고리 필터 그리드와 상품 카드 목록',
            },
            {
                src: '/assets/img/work/b2c-mall-mobile-home.png',
                alt: '모바일 홈: 검색·상단 탭, 이벤트 배너, 퀵 메뉴 아이콘, 인기 상품 카드, 하단 고정 내비',
            },
            {
                src: '/assets/img/work/b2c-mall-login.png',
                alt: '로그인: 아이디·비밀번호, 아이디 저장 및 계정 찾기 링크',
            },
        ],
        goals: {
            body:
                '첫 화면에서 브랜드와 현재 진행 중인 혜택을 인지한 뒤, 카테고리 또는 베스트로 자연스럽게 이동하도록 시선 흐름을 설계했습니다. 운영 측면에서는 배너·추천 영역 교체 시 개발 의존도를 낮추는 것을 목표로 했습니다.',
            counters: [
                { value: '1', suffix: '', label: '통합 몰 랜딩' },
                { value: '5', suffix: '+', label: '핵심 프로모션 블록' },
                { value: '20', suffix: '+', label: '베스트 그리드 노출 슬롯' },
                { value: '100', suffix: '%', label: '반응형 대응' },
            ],
        },
        solution: {
            body:
                '히어로·서브 배너·아이콘 행·상품 타일을 공통 스페이싱과 타이포 스케일로 묶고, 이미지 비율(aspect ratio)을 맞춰 긴 풀페이지 캡처에서도 블록 경계가 명확히 보이도록 했습니다. CTA·장바구니·검색 등 상단 유틸은 모든 구간에서 동일한 위치를 유지해 학습 비용을 줄였습니다.',
        },
        gallery: {
            images: [
                '/assets/img/work/b2c-mall-main-landing.png',
                '/assets/img/work/b2c-mall-best-products.png',
                '/assets/img/work/b2c-mall-mobile-home.png',
                '/assets/img/work/b2c-mall-login.png',
                '/assets/img/work/b2c-mall-member-signup.png',
                '/assets/img/work/b2c-mall-admin-orders.png',
                '/assets/img/work/b2c-mall-admin-site-settings.png',
                '/assets/img/work/b2c-mall-admin-dashboard.png',
                '/assets/img/work/b2c-mall-admin-products.png',
                '/assets/img/work/b2c-mall-admin-vendors.png',
                '/assets/img/work/b2c-mall-admin-main-page.png',
                '/assets/img/work/b2c-mall-admin-members.png',
            ],
            alts: [
                '통합 온라인 쇼핑몰: 메인~푸터 풀 페이지 구성',
                '베스트 상품 목록: 카테고리 탭과 상품 그리드',
                '모바일 홈: 검색·탭 메뉴, 프로모 배너, 퀵 아이콘, 인기 상품, 하단 내비',
                '로그인: 공통 헤더와 인증 폼',
                '회원가입: 단계 표시, 필수 입력·약관 동의',
                '관리자: 전체 주문 목록·상태 탭·검색',
                '관리자: 사이트 환경설정·기본정보·기타 설정',
                '관리자: 대시보드·주문·배송·통계 위젯',
                '관리자: 상품 등록·목록·검색 필터',
                '관리자: 입점사 목록·페이징',
                '관리자: 메인페이지 구성·노출 순서·미리보기',
                '관리자: 회원정보·검색·목록',
            ],
        },
        sidebar: PROJECT_DETAILS_B2C_ECOMMERCE_SIDEBAR,
    },

    /** B2C 몰 동일 프로젝트 라인 — Android·iOS 네이티브 앱 */
    'b2c-mall-mobile-apps': {
        meta: {
            title: 'B2C몰 앱 개발 (Android·iOS) | CODAM 구축 사례',
            description:
                '동일 B2C 몰 서비스의 Android·iOS 네이티브 앱으로, 홈·탐색·장바구니·결제까지 한 손 사용성을 중심에 둔 모바일 앱 구축 사례입니다.',
        },
        pageTitle: {
            title: 'B2C몰 앱 개발 (Android·iOS)',
            parentTo: '/software-development',
            parentLabel: '소프트웨어 개발',
        },
        infoBackgroundImage: '/assets/img/work/b2c-mall-mobile-home.png',
        hero: {
            title: 'B2C몰 앱 개발 (Android·iOS)',
            lead:
                '웹 몰과 동일한 카탈로그·주문 도메인을 공유하면서도, 앱 전용 내비게이션·제스처·푸시 알림으로 재방문과 전환을 높이는 것을 목표로 했습니다. 상단 검색·카테고리 탭, 메인 프로모 배너, 퀵 메뉴 아이콘, 인기 상품 그리드, 하단 고정 탭으로 실제 매장 앱과 같은 동선을 구현했고 iOS·Android 각 플랫폼 가이드에 맞춘 UI 패턴을 적용했습니다.',
        },
        info: genericInfo({
            type: 'B2C 이커머스 · 네이티브 앱',
            tags: 'Android / iOS / 푸시 / 스토어 배포',
            client: '비공개 (B2C 리테일)',
            start: '2024년',
            duration: '웹 몰 구축과 병행·연속',
        }),
        introParagraph:
            '앱은 세션 단위가 짧고 이탈이 잦은 채널이라, 첫 실행에서 카테고리·혜택·주문 조회까지 도달하는 스텝 수를 줄이는 데 집중했습니다. 홈 화면은 이벤트 배너와 지금 잘나가는 상품 영역을 스와이프 친화적으로 배치하고, 하단 탭으로 카테고리·검색·MY·결제(예: QR) 등 핵심 진입을 고정했습니다. 로그인·회원 정보는 웹과 계정을 통합해 운영 부담을 나누되, 앱에서는 생체 로그인·자동 로그인 정책을 선택적으로 지원할 수 있도록 설계했습니다.',
        challenge: {
            body:
                '웹 반응형과 화면을 그대로 옮기면 터치 타깃과 스크롤 깊이가 맞지 않아 이탈이 늘어납니다. 또 스토어 심사·OS 버전별 동작 차이, 결제·딥링크 연동 이슈를 동시에 다뤄야 해서 릴리즈 일정과 회귀 테스트 범위를 관리하는 것이 과제였습니다.',
            bullets: [
                '홈·리스트·상세·장바구니·결제까지 공통 컴포넌트와 화면 전환 규칙 정리',
                '백그라운드 푸시·딥링크로 이벤트·주문 상태 안내 시 랜딩 일관성 유지',
                'Play·App Store 메타데이터·스크린샷·권한 문구 등 심사 대비 체크리스트 운영',
            ],
        },
        previewSlides: [
            {
                src: '/assets/img/work/b2c-mall-mobile-home.png',
                alt: '앱 홈: 검색·탭, 이벤트 배너, 퀵 메뉴, 인기 상품, 하단 내비',
            },
            {
                src: '/assets/img/work/b2c-mall-app-category-drawer.png',
                alt: '카테고리 드로어: 전체 카테고리 목록·스크롤·닫기',
            },
            {
                src: '/assets/img/work/b2c-mall-app-my-page.png',
                alt: '마이페이지: 주문 요약·배송 단계·주문 관리·메뉴 리스트',
            },
            {
                src: '/assets/img/work/b2c-mall-app-local-list.png',
                alt: '주변 매장·제휴 목록: 지역·카테고리 필터, 업체 카드·이미지 슬라이더',
            },
            {
                src: '/assets/img/work/b2c-mall-app-wallet-home.png',
                alt: '통합 홈: 포인트·예치금·쿠폰 요약, 바로가기·MY 메뉴 그리드',
            },
            {
                src: '/assets/img/work/b2c-mall-app-store-map.png',
                alt: '매장 지도: 지도·목록 전환, 카테고리 칩, 위치 핀·라벨',
            },
        ],
        goals: {
            body:
                '웹과 동일한 신뢰(주문·배송·교환 안내)를 유지하면서, 앱만의 빠른 재진입·알림 기반 리마인드를 통해 재구매 동선을 짧게 만드는 것을 목표로 했습니다.',
            counters: [
                { value: '2', suffix: '', label: '플랫폼 (Android·iOS)' },
                { value: '5', suffix: '', label: '하단 핵심 탭' },
                { value: '1', suffix: '', label: '통합 회원·주문 도메인' },
                { value: '100', suffix: '%', label: '스토어 정책 대응' },
            ],
        },
        solution: {
            body:
                '쇼핑 홈은 상단 검색·가로 탭 메뉴(홈·베스트·이벤트 등), 메인 프로모션 배너 슬라이드, 타임세일·베스트 등 원형 퀵 메뉴, 「인기 상품」 가로 스크롤 카드로 구성하고 장바구니·하단 5탭(카테고리·검색·홈·MY·QR결제)으로 모든 주요 진입을 한 줄 안에서 닿게 맞췄습니다. 카테고리는 전체 메뉴를 세로 리스트·오버레이 드로어로 열어 깊은 카탈로그도 스크롤 한 번에 탐색하도록 했고, 마이페이지에서는 주문금액·포인트·예치금·쿠폰·장바구니 요약과 결제~구매확정 단계 트래커, 취소·교환·반품 건수, 주문·배송조회·예치금·찜 등 후속 메뉴를 한 화면에서 확인할 수 있게 묶었습니다. 오프라인·제휴 동선은 현재 지역·업종 칩 필터와 지도·목록 전환, 업체 카드 내 이미지 슬라이더로 매장·상품을 함께 노출했고, 별도 통합 화면에서는 공지·환영 영역 아래 포인트·페이·예치금·쿠폰 잔액 카드와 쇼핑몰·제휴몰 등 바로가기, 주문·배송·배송지·리뷰·쿠폰함 등 MY 그리드 메뉴를 제공해 멤버십·결제 허브 역할을 분리했습니다. 매장 찾기는 지도 뷰에서 카테고리별 필터와 위치 핀·라벨을 함께 쓰도록 해 근처 매장 탐색과 방문 전환을 연결했으며, 동일한 하단 탭 체계를 모든 주요 화면에 유지해 학습 비용을 줄였습니다. 구현 측면에서는 공통 간격·타이포·컬러 토큰과 리스트·카드·칩 컴포넌트를 재사용하고, 웹과 공유하는 주문·회원 API와 앱 전용 푸시·버전·위치 연동을 분리했으며 오류 시 안내 문구와 재시도를 통일했습니다.',
        },
        gallery: {
            images: [
                '/assets/img/work/b2c-mall-app-gallery-home.png',
                '/assets/img/work/b2c-mall-app-category-drawer.png',
                '/assets/img/work/b2c-mall-app-my-page.png',
                '/assets/img/work/b2c-mall-app-local-list.png',
                '/assets/img/work/b2c-mall-app-wallet-home.png',
                '/assets/img/work/b2c-mall-app-store-map.png',
            ],
            alts: [
                '모바일 앱 홈·프로모·인기 상품',
                '카테고리 전체 메뉴',
                '마이페이지·주문·혜택 요약',
                '주변 매장·제휴 목록',
                '통합 홈·자산·바로가기',
                '매장 위치 지도',
            ],
        },
        sidebar: PROJECT_DETAILS_B2C_MOBILE_APPS_SIDEBAR,
    },

    'web-product-development': {
        meta: {
            title: '웹 프로덕트 개발 | CODAM 구축 사례',
            description: '확장 가능한 구조로 웹 제품을 개발하고 배포 파이프라인을 정리한 사례입니다.',
        },
        pageTitle: { title: '웹 프로덕트 개발', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '웹 프로덕트 개발',
            lead: '도메인 경계·모듈 구조·배포 전략을 초기에 합의하고, 기능 팀이 병렬로 확장할 수 있는 웹 제품을 납품했습니다.',
        },
        info: genericInfo({ type: '웹 제품 · SPA', tags: 'CI/CD / 모듈 구조' }),
        introParagraph: '성능 예산과 번들 분석을 반복해 초기 로딩과 상호작용 지연을 관리했습니다.',
        challenge: {
            body: '릴리즈 주기가 짧아 회귀 테스트 자동화와 기능 플래그가 필수였습니다.',
            bullets: ['스테이징·프로덕션 환경 분리', '관측 가능성(로그·메트릭)'],
        },
        previewSlides: [{ src: '/assets/img/work/project-5.jpg', alt: '웹 프로덕트' }],
        goals: {
            body: '배포 빈도와 장애 복구 시간 목표를 합의하고 대시보드로 추적했습니다.',
            counters: [
                { value: '2', suffix: '주', label: '스프린트 단위' },
                { value: '10', suffix: '+', label: '독립 모듈' },
            ],
        },
        solution: { body: 'API 계약 테스트와 E2E 스모크를 파이프라인에 포함해 회귀를 줄였습니다.' },
        gallery: { images: ['/assets/img/work/project-5.jpg'], alts: ['웹 프로덕트'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'enterprise-work-app': {
        meta: {
            title: '기업용 업무 앱 | CODAM 구축 사례',
            description: '현장·본사 사용자를 고려한 기업용 업무 애플리케이션 구축 사례입니다.',
        },
        pageTitle: { title: '기업용 업무 앱', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '기업용 업무 앱',
            lead: '승인·알림·오프라인 동기 등 실무 규칙을 반영한 업무 앱으로 현장 생산성 개선을 목표로 했습니다.',
        },
        info: genericInfo({ type: '업무 앱 · 모바일', tags: '오프라인 / 동기화' }),
        introParagraph: '역할·조직 단위 권한과 감사 로그를 기본으로 설계했습니다.',
        challenge: {
            body: '저대역 환경에서도 필수 기능이 동작해야 했습니다.',
            bullets: ['충돌 해결 정책', '단말 보안 정책 연동'],
        },
        previewSlides: [{ src: '/assets/img/work/project-6.jpg', alt: '기업용 업무 앱' }],
        goals: {
            body: '작업 완료 시간과 오류율을 KPI로 삼고 개선 루프를 돌렸습니다.',
            counters: [
                { value: '50', suffix: '%', label: '처리 시간 단축 목표' },
                { value: '1', suffix: '', label: '통합 계정' },
            ],
        },
        solution: { body: '백그라운드 동기 큐와 사용자 피드백 UI를 분리해 안정성을 높였습니다.' },
        gallery: { images: ['/assets/img/work/project-6.jpg'], alts: ['기업용 업무 앱'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'app-lifecycle-delivery': {
        meta: {
            title: '앱 기획부터 운영까지 | CODAM 구축 사례',
            description: '기획 단계부터 운영 모니터링까지 전 주기를 함께한 앱 프로젝트 사례입니다.',
        },
        pageTitle: { title: '앱 기획부터 운영까지', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '앱 기획부터 운영까지',
            lead: '요구사항 워크숍·프로토타입·출시·운영 대시보드까지 한 파트너십으로 수행했습니다.',
        },
        info: genericInfo({ type: '앱 · 풀사이클', tags: '기획 / 개발 / 운영' }),
        introParagraph: '출시 후 크래시·성능 지표를 주간으로 리뷰하는 운영 리듬을 세웠습니다.',
        challenge: {
            body: '초기 스코프와 시장 피드백 사이의 균형을 맞추기 위해 단계적 릴리즈를 채택했습니다.',
            bullets: ['MVP 범위 합의', '스토어 운영 가이드'],
        },
        previewSlides: [{ src: '/assets/img/work/project-7.jpg', alt: '앱 풀사이클' }],
        goals: {
            body: '사용자 리텐션과 주요 태스크 완료율을 단계별로 목표화했습니다.',
            counters: [
                { value: '4', suffix: '', label: '마일스톤' },
                { value: '24', suffix: '/7', label: '모니터링' },
            ],
        },
        solution: { body: '기능 토글과 원격 설정으로 운영 중 실험을 안전하게 수행했습니다.' },
        gallery: { images: ['/assets/img/work/project-7.jpg'], alts: ['앱 운영'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'custom-security-architecture': {
        meta: {
            title: '맞춤 보안 아키텍처 | CODAM 구축 사례',
            description: '업종·규제 요건을 반영한 맞춤형 보안 아키텍처 설계·구현 사례입니다.',
        },
        pageTitle: { title: '맞춤 보안 아키텍처', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '맞춤 보안 아키텍처',
            lead: '네트워크 분리·암호화·키 관리·접근 통제를 포함한 방어 심층 설계를 제품에 녹였습니다.',
        },
        info: genericInfo({ type: '보안 아키텍처', tags: '규제 대응 / 위협 모델링' }),
        introParagraph: '위협 모델링 워크숍 결과를 요구사항으로 추적 가능하게 관리했습니다.',
        challenge: {
            body: '클라우드·온프레 혼합 환경에서 일관된 정책을 적용해야 했습니다.',
            bullets: ['침투 테스트 대응', '로그 보존 정책'],
        },
        previewSlides: [{ src: '/assets/img/work/project-8.jpg', alt: '보안 아키텍처' }],
        goals: {
            body: '인증·인가 경계를 명확히 하고 최소 권한 원칙을 코드 레벨에서 강제했습니다.',
            counters: [
                { value: '100', suffix: '%', label: '전송 구간 암호화' },
                { value: '3', suffix: '', label: '보안 존' },
            ],
        },
        solution: { body: '시크릿 관리·로테이션 절차와 장애 시 폴백을 문서화했습니다.' },
        gallery: { images: ['/assets/img/work/project-8.jpg'], alts: ['보안 아키텍처'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'smart-industry-digitalization': {
        meta: {
            title: '스마트 산업 디지털화 | CODAM 구축 사례',
            description: '장비·데이터 연동을 통해 산업 현장의 디지털 전환을 지원한 사례입니다.',
        },
        pageTitle: { title: '스마트 산업 디지털화', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '스마트 산업 디지털화',
            lead: '현장 설비 데이터를 수집·가공해 가동률·품질 지표를 실시간으로 보여 주는 산업용 포털입니다.',
        },
        info: genericInfo({ type: '산업 · IoT 연동', tags: '데이터 파이프라인 / 현장 UI' }),
        introParagraph: 'OT·IT 경계에서의 보안과 지연 요구사항을 동시에 만족시키는 아키텍처를 선택했습니다.',
        challenge: {
            body: '레거시 프로토콜과 신규 API를 브리지하는 어댑터 계층이 필요했습니다.',
            bullets: ['엣지 게이트웨이', '알람·에스컬레이션'],
        },
        previewSlides: [{ src: '/assets/img/work/project-9.jpg', alt: '스마트 산업' }],
        goals: {
            body: '가동 중단 시간과 불량률 추적을 우선 과제로 삼았습니다.',
            counters: [
                { value: '1000', suffix: '+', label: '초당 이벤트 처리' },
                { value: '15', suffix: '', label: '현장 라인 연동' },
            ],
        },
        solution: { body: '시계열 저장과 대시보드를 분리해 조회 성능과 수집 안정성을 확보했습니다.' },
        gallery: { images: ['/assets/img/work/project-9.jpg'], alts: ['스마트 산업'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    /** 슬라이더·임시 링크용 — 제조 ERP 사례 */
    'manufacturing-erp-platform': {
        meta: {
            title: '제조 기업 ERP 연동 플랫폼 | CODAM 구축 사례',
            description: '기존 ERP와 연동되는 생산·발주·재고 통합 플랫폼 구축 사례입니다.',
        },
        pageTitle: { title: '제조 기업 ERP 연동 플랫폼', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '제조 기업 ERP 연동 플랫폼',
            lead: '실시간 생산 현황과 발주·재고 흐름을 하나의 대시보드에서 다루도록 통합했습니다.',
        },
        info: genericInfo({ type: '제조 · ERP 연동', tags: 'MES / API' }),
        introParagraph: '현장 단말과 본사 시스템 간 데이터 정합성을 맞추는 것이 핵심이었습니다.',
        challenge: {
            body: 'ERP 커스터마이징 이력이 길어 인터페이스 명세 정리에 시간을 투자했습니다.',
            bullets: ['마스터 데이터 동기화', '예외 처리 워크플로'],
        },
        previewSlides: [{ src: '/assets/img/work/case-1b.jpg', alt: '제조 ERP 연동' }],
        goals: {
            body: '업무 처리 리드타임 단축을 정량 목표로 삼았습니다.',
            counters: [
                { value: '40', suffix: '%', label: '처리 시간 개선 목표' },
                { value: '1', suffix: '', label: '통합 뷰' },
            ],
        },
        solution: { body: '이벤트 기반 동기화와 배치 대사를 병행해 데이터 품질을 유지했습니다.' },
        gallery: { images: ['/assets/img/work/case-1b.jpg'], alts: ['제조 ERP'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'ai-finance-document-system': {
        meta: {
            title: 'AI 금융 문서 자동 처리 | CODAM 구축 사례',
            description: '비정형 금융 문서를 AI로 분류·추출하는 RPA 연동 시스템 사례입니다.',
        },
        pageTitle: { title: 'AI 기반 금융 문서 자동 처리', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: 'AI 기반 금융 문서 자동 처리',
            lead: '계약서·약관 등 문서를 자동 분류하고 필요 필드를 추출해 후속 업무 시스템으로 넘깁니다.',
        },
        info: genericInfo({ type: 'AI · RPA', tags: '문서 AI / 워크플로' }),
        introParagraph: '모델 신뢰도 임계치와 사람 검수 큐를 함께 설계했습니다.',
        challenge: {
            body: '문서 양식 변형이 많아 학습 데이터 라벨링 전략이 중요했습니다.',
            bullets: ['감사 추적', '버전별 모델 배포'],
        },
        previewSlides: [{ src: '/assets/img/work/case-2b.jpg', alt: 'AI 금융 문서' }],
        goals: {
            body: '처리 건당 소요 시간과 자동화율을 KPI로 관리했습니다.',
            counters: [
                { value: '8', suffix: 'x', label: '처리 속도 목표' },
                { value: '95', suffix: '%', label: '자동 분류 목표' },
            ],
        },
        solution: { body: '저신뢰 건은 큐에 남기고 운영자 피드백으로 모델을 점진 개선했습니다.' },
        gallery: { images: ['/assets/img/work/case-2b.jpg'], alts: ['AI 문서'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'cloud-crm-platform': {
        meta: {
            title: '클라우드 고객 관리 플랫폼 | CODAM 구축 사례',
            description: '전국 지점 통합 고객 데이터와 마케팅 자동화를 지원하는 클라우드 CRM 사례입니다.',
        },
        pageTitle: { title: '클라우드 기반 고객 관리 플랫폼', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '클라우드 기반 고객 관리 플랫폼',
            lead: '지점별 데이터를 표준 모델로 통합하고 캠페인·세그먼트를 시각적으로 운영합니다.',
        },
        info: genericInfo({ type: 'CRM · 클라우드', tags: '마케팅 자동화' }),
        introParagraph: '개인정보 최소화·동의 관리를 UI 흐름에 포함했습니다.',
        challenge: {
            body: '데이터 이관 중 품질 이슈를 단계적 검증으로 걸러냈습니다.',
            bullets: ['세그먼트 재계산 배치', '권한 위임'],
        },
        previewSlides: [{ src: '/assets/img/work/case-3b.jpg', alt: 'CRM 플랫폼' }],
        goals: {
            body: '캠페인 전환과 재방문율을 대시보드에 노출했습니다.',
            counters: [
                { value: '35', suffix: '%', label: 'ROI 개선 목표' },
                { value: '100', suffix: '+', label: '지점 템플릿' },
            ],
        },
        solution: { body: '이벤트 스트림과 배치 요약을 나눠 마케팅 팀의 즉시성 요구를 맞췄습니다.' },
        gallery: { images: ['/assets/img/work/case-3b.jpg'], alts: ['CRM'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },

    'public-bi-dashboard': {
        meta: {
            title: '데이터 시각화 대시보드 | CODAM 구축 사례',
            description: '다양한 소스 데이터를 통합해 경영 의사결정을 지원하는 BI 대시보드 사례입니다.',
        },
        pageTitle: { title: '데이터 시각화 대시보드 구축', parentTo: '/project-grid', parentLabel: '구축 사례' },
        hero: {
            title: '데이터 시각화 대시보드 구축',
            lead: '부서 간 정의가 다른 지표를 정렬하고 단일 진실 공급원에 가깝게 맞추는 것이 목표였습니다.',
        },
        info: genericInfo({ type: 'BI · 대시보드', tags: '데이터 허브' }),
        introParagraph: '드릴다운 깊이와 성능 사이의 균형을 맞추기 위해 사전 집계 레이어를 두었습니다.',
        challenge: {
            body: '레거시 DB 부하를 줄이기 위해 읽기 전용 복제와 캐시를 활용했습니다.',
            bullets: ['지표 사전 관리', '엑세스 감사'],
        },
        previewSlides: [{ src: '/assets/img/work/case-1b.jpg', alt: 'BI 대시보드' }],
        goals: {
            body: '경영 회의 주기에 맞춘 자동 리포트 배포를 구현했습니다.',
            counters: [
                { value: '50', suffix: '+', label: '공식 지표' },
                { value: '5', suffix: '분', label: '새로고침 SLA' },
            ],
        },
        solution: { body: '위젯 단위 권한과 공유 링크 만료 정책으로 정보 유출 위험을 줄였습니다.' },
        gallery: { images: ['/assets/img/work/case-1b.jpg'], alts: ['BI'] },
        sidebar: PROJECT_DETAILS_SERVICE_SIDEBAR,
    },
}

/** 구 URL·북마크 호환 (브랜드명 제거 전 슬러그) */
const CASE_STUDY_SLUG_ALIASES = {
    'agarmall-ecommerce-platform': 'b2c-ecommerce-platform',
}

/** `useParams().slug` 등 → CASE_STUDIES 키 */
export function resolveCaseStudySlugKey(urlSlug) {
    if (!urlSlug) return null
    return CASE_STUDY_SLUG_ALIASES[urlSlug] ?? urlSlug
}

export function getCaseStudyBySlug(slug) {
    const resolved = resolveCaseStudySlugKey(slug)
    if (!resolved || !CASE_STUDIES[resolved]) return null
    return CASE_STUDIES[resolved]
}

export function listCaseStudySlugs() {
    return Object.keys(CASE_STUDIES)
}

export const PROJECT_SLUG = {
    BLOCKCHAIN_ECOSYSTEM: 'blockchain-ecosystem',
}

/** CaseSliderOne 등: 슬라이드 `title` → 상세 슬러그 */
export const CASE_SLIDER_TITLE_TO_SLUG = {
    '블록체인 생태계 웹·앱 구축': 'blockchain-ecosystem',
    'Premium Auto Concierge 웹·CRM 구축': 'premium-auto-concierge',
    '프리미엄 오토 컨시어지(PAC) 웹·CRM 구축': 'premium-auto-concierge',
    '디지털 자산 거래 플랫폼 랜딩': 'digital-assets-exchange-platform',
    '디지털 자산 거래 플랫폼 개발': 'digital-assets-exchange-platform',
    '제조 기업 ERP 연동 통합 플랫폼': 'manufacturing-erp-platform',
    'AI 기반 금융 문서 자동 처리 시스템': 'ai-finance-document-system',
    '클라우드 기반 고객 관리 플랫폼': 'cloud-crm-platform',
    '데이터 시각화 대시보드 구축': 'public-bi-dashboard',
    '다채널 매출·정산 통합 백오피스': 'web-product-development',
    '통합 온라인 쇼핑몰 플랫폼 구축': 'b2c-ecommerce-platform',
    'B2C몰 앱 개발 (Android·iOS)': 'b2c-mall-mobile-apps',
}

/** FeatureSliderOne: `bTitle` → 상세 슬러그 */
export const FEATURE_SLIDER_BTITLE_TO_SLUG = {
    'ERP 연동 통합 플랫폼': 'manufacturing-erp-platform',
    'AI 문서 자동화 시스템': 'ai-finance-document-system',
    '고객 관리 플랫폼': 'cloud-crm-platform',
    '데이터 시각화 대시보드': 'public-bi-dashboard',
    '보안 중심 웹 플랫폼 고도화': 'unified-security-operations',
}

/** 홈 「주요 구축 사례」슬라이더 — 그리드 상단 4건과 동일(기술 인사이트 `blog-style-one` 카드 효과와 공유) */
export const HOME_FEATURE_SLIDER_ITEMS = [
    {
        tag: '자동차 / 컨시어지',
        title: '프리미엄 오토 컨시어지(PAC) 웹·CRM 구축',
        desc: 'pac.codam.co.kr — KCC오토 공식 컨설턴트 1:1 상담, 모델·프로모션·견적·방문·시승 예약, 회원·마이페이지와 CRM 관리자까지 구축한 프리미엄 오토 컨시어지 사례입니다.',
        imgSrc: '/assets/img/work/premium-auto-concierge-landing.png',
        slug: 'premium-auto-concierge',
        tagModifier: 'tag-04',
    },
    {
        tag: '핀테크 / 거래 플랫폼',
        title: '디지털 자산 거래 플랫폼 개발',
        desc: '랜딩·스팟 거래 터미널(차트·호가·체결·주문)과 로그인 후 자산 개요·단계형 출금·펀딩↔현물 이체·보안(2FA·PIN)까지 한 다크·골드 톤 웹 플랫폼으로 개발했으며, 반응형으로 모바일·태블릿에서도 동일 플로우가 이어지도록 구현했습니다.',
        imgSrc: '/assets/img/work/digital-assets-exchange-landing.png',
        slug: 'digital-assets-exchange-platform',
        tagModifier: '',
    },
    {
        tag: 'Web3 / 플랫폼',
        title: '블록체인 생태계 웹·앱 구축',
        desc: 'NFT·실물자산 연계·스테이킹·로드맵을 한 흐름으로 전달하는 반응형 랜딩, 관리자·모바일 UI까지 브랜드 톤을 맞춘 비공개 클라이언트 사례입니다.',
        imgSrc: '/assets/img/work/flc-rwa-ecosystem.png',
        slug: 'blockchain-ecosystem',
        tagModifier: 'tag-02',
    },
    {
        tag: '이커머스 / 플랫폼',
        title: '통합 온라인 쇼핑몰 플랫폼 구축',
        desc: '메인·베스트·이벤트·카테고리 내비와 상품 그리드, 푸터까지 일체형 랜딩. 검색·장바구니·회원 동선을 고려한 B2C 몰 UI를 구축했습니다.',
        imgSrc: '/assets/img/work/b2c-mall-main-landing.png',
        slug: 'b2c-ecommerce-platform',
        tagModifier: 'tag-03',
    },
    {
        tag: '이커머스 / 네이티브 앱',
        title: 'B2C몰 앱 개발 (Android·iOS)',
        desc: '동일 몰 서비스의 네이티브 앱으로 홈·카테고리·마이·주변 매장·지도·자산 허브까지 한 손 동선으로 묶었습니다. 푸시·스토어 배포까지 포함한 앱 구축 사례입니다.',
        imgSrc: '/assets/img/work/b2c-mall-app-gallery-home.png',
        slug: 'b2c-mall-mobile-apps',
        tagModifier: '',
    },
]

/**
 * 구축 사례 슬라이드·카드 공통: 상세 경로용 슬러그
 * @param {{ detailSlug?: string, slug?: string, title?: string, img?: string, imgSrc?: string }} item
 */
export function resolveCaseStudyDetailSlug(item) {
    if (!item) return 'web-analytics-dashboard'
    if (item.detailSlug) return item.detailSlug
    if (item.slug) return item.slug
    if (item.title && CASE_SLIDER_TITLE_TO_SLUG[item.title]) {
        return CASE_SLIDER_TITLE_TO_SLUG[item.title]
    }
    return resolvePortfolioDetailSlug(item)
}

/** 그리드·메이슨리 카드의 `img` 키 → 상세 슬러그 */
export const PORTFOLIO_IMG_TO_SLUG = {
    'project-1': 'web-analytics-dashboard',
    'project-2': 'unified-security-operations',
    'project-3': 'mobile-service-platform',
    'project-4': 'brand-visual-identity',
    'project-5': 'web-product-development',
    'project-6': 'enterprise-work-app',
    'project-7': 'app-lifecycle-delivery',
    'project-8': 'custom-security-architecture',
    'project-9': 'smart-industry-digitalization',
}

/**
 * @param {{ slug?: string, img?: string, imgSrc?: string }} item
 */
export function resolvePortfolioDetailSlug(item) {
    if (item.slug) return item.slug
    if (item.imgSrc && item.imgSrc.includes('flc-rwa-ecosystem')) return PROJECT_SLUG.BLOCKCHAIN_ECOSYSTEM
    if (item.imgSrc && item.imgSrc.includes('b2c-mall-main-landing')) return 'b2c-ecommerce-platform'
    if (item.imgSrc && item.imgSrc.includes('b2c-mall-mobile-home')) return 'b2c-mall-mobile-apps'
    if (item.imgSrc && item.imgSrc.includes('b2c-mall-app-gallery-home')) return 'b2c-mall-mobile-apps'
    if (item.imgSrc && item.imgSrc.includes('digital-assets-exchange-landing')) return 'digital-assets-exchange-platform'
    if (item.img && PORTFOLIO_IMG_TO_SLUG[item.img]) return PORTFOLIO_IMG_TO_SLUG[item.img]
    return 'web-analytics-dashboard'
}
